import React from 'react';
import Footer from '../Footer';
import biztonsagIcon from '../../img/biztonsag.png';
import egeszsegIcon from '../../img/egeszseg.png';
import etkezesIcon from '../../img/etkezes.png';
import kozossegIcon from '../../img/kozosseg.png';
import tamogatasIcon from '../../img/tamogatas.png';
import './styles/SubInfoPage.css';

const SectionTitle = ({ icon, alt, children }) => (
  <h4 className="content-icon-heading">
    <img src={icon} alt={alt} className="content-heading-icon" />
    <span>{children}</span>
  </h4>
);

const AboutUsPage = () => {
  return (
    <div className="sub-info-page">
      <section className="sub-info-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Magunkról</h2>
            <p className="section-subtitle">
              Bemutatkozás és intézményi információk
            </p>
          </div>

          <div className="content-card">
            <h3>Az intézményről</h3>
            <div className="content-body">
              <p><strong>Célunk</strong>, hogy a nálunk élők számára biztosítsuk a nekik legmegfelelőbb környezetet és körülményeket a boldog, nyugodt nyugdíjas évekhez.</p>
              
              <p>A Napvirág Idősek Otthona személyes gondoskodást nyújtó bentlakásos intézmény Budakalászon, amely tartós elhelyezést biztosít átlagot meghaladó minőségű elhelyezési körülmények között, modern, négyszintes épületben, 2006. februárjától. Az épületben 123 akadálymentes, kényelmesen, otthonosan berendezhető, napfényes apartman mellett számos olyan helység található, amik lakóink jó közérzetét biztosítják:</p>

              <SectionTitle icon={etkezesIcon} alt="" >Étkezés és közösségi terek</SectionTitle>
              <ul>
                <li><strong>Tágas étterem</strong>, modern, jól felszerelt konyhával, ahol a napi ötszöri étkezést biztosítjuk. Ételeinket a könnyű vegyes étrend összeállításának szabályai határozzák meg, de nagy számban készülnek orvosi elrendelésre diéták is.</li>
                <li><strong>Kényelmes, otthonosan berendezett közösségi tér</strong>, ami helyet ad nagyobb rendezvényeinknek is.</li>
                <li><strong>Meghitt, olvasnivalóban gazdag könyvtár</strong>, ahol kiscsoportos foglalkozásainkat tartjuk. Ebben a helységben lehetőség van kisebb családi összejövetelek megrendezésére is.</li>
              </ul>

              <SectionTitle icon={egeszsegIcon} alt="" >Egészségügyi ellátás</SectionTitle>
              <ul>
                <li><strong>Orvosi rendelő</strong>, ahol heti két alkalommal rendel háziorvosunk és havonta egy-egy alkalommal pszichiáter, neurológus, reumatológus, bőrgyógyász, sebész, diabetológus szakorvos biztosít konzultációs lehetőséget. Lakóink egészségi állapotát rendszeresen végzett szűrésekkel figyeljük.</li>
                <li><strong>Tornaterem</strong> biztosítja lakóink aktív kikapcsolódását, fizikai erőnlétének javítását, fenntartását.</li>
                <li><strong>Gyógytornászaink</strong> a hét öt napján tartanak egyéni és csoportos foglalkozásokat.</li>
              </ul>

              <SectionTitle icon={tamogatasIcon} alt="" >Lelki gondozás és szolgáltatások</SectionTitle>
              <ul>
                <li><strong>Ökumenikus kápolna</strong> áll nyitva a vallásukat gyakorlók előtt.</li>
                <li><strong>Fodrász, kozmetikus, manikűrös, pedikűrös és masszőr</strong> szolgáltatásait vehetik igénybe a felfrissülni és szépülni vágyók.</li>
                <li>Az egészségügyi ellátás mellett kiemelten fontos terület a lakók <strong>lelki-, és mentális gondozása</strong>. Havonta egyszer ökumenikus lelki délelőtt keretében találkozhatnak lelkésszel.</li>
              </ul>

              <SectionTitle icon={kozossegIcon} alt="" >Programok és tevékenységek</SectionTitle>
              <p>A mentálhigiénés munkatársak színes változatos programokat szerveznek. Ezek között rendszeresen szerepelnek kártya- és társasjátékok, beszélgetések, filmvetítések, sportfoglalkozások. A lakók egészségi állapotának függvényében alkalmanként kirándulunk, színházba, múzeumba járunk.</p>

              <SectionTitle icon={biztonsagIcon} alt="" >Infrastruktúra és biztonság</SectionTitle>
              <p>Legfontosabb feladatunk a fizikai szükségletek kielégítése, amibe beletartozik az apartmanok és a közös helységek fűtése, világítása, meleg,- és hideg vízzel történő ellátása, valamint azok takarítása, karbantartása, de a mosás, vasalás is.</p>
              
              <p>Apartmanjainkat és az egész épületet igyekeztünk úgy kialakítani, hogy az mind funkciójában, mind minőségében képes legyen megfelelni a legmagasabb elvárásoknak. Az épületre és annak berendezési tárgyaira vagyonbiztosítással rendelkezünk, ami kiterjed a természeti és egyéb károk eseteire is.</p>

              <SectionTitle icon={tamogatasIcon} alt="" >Érdekképviselet</SectionTitle>
              <p>Lakóinkat érintő változásokban az Érdekképviseleti Fórum véleményét, tanácsait kérjük. A jogsérelmeket a fórum mellett ellátott jogi képviselő segít orvosolni.</p>
              
              <p><em>További információk a Dokumentumok menüben elérhetőek.</em></p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AboutUsPage;
